import React from "react";
import { FileText, Search, BadgeIndianRupee, ShieldCheck, Truck } from "lucide-react";

const STEPS = [
  { icon: FileText, title: "Share Requirement", desc: "Submit your asset list or site details." },
  { icon: Search, title: "On-Site Inspection", desc: "Technical assessment by our team." },
  { icon: BadgeIndianRupee, title: "Commercial Offer", desc: "One guaranteed valuation for the lot." },
  { icon: ShieldCheck, title: "Data Sanitization", desc: "Certified wiping & safe disassembly." },
  { icon: Truck, title: "Payment & Pickup", desc: "Settlement and multi-city logistics." },
];

export const CorpProcess = () => (
  <section id="process" data-testid="corporate-process-section" className="home-section home-section--corporate scroll-mt-24" style={{ background: "#F8FBF4" }}>
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <p className="text-[12px] font-bold uppercase tracking-[0.16em]" style={{ color: "#E8501A" }}>Process</p>
      <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl" style={{ color: "var(--green-950)" }}>
        How It Works for Corporates
      </h2>
      <div className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-5 lg:gap-4">
        {STEPS.map((s, i) => (
          <div key={s.title} data-testid={`process-step-${i + 1}`} className="relative flex gap-4 lg:block">
            <div className="flex flex-col items-center lg:mb-4 lg:flex-row lg:gap-3">
              <div className="relative flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-white"
                   style={{ background: "var(--green-800)" }}>
                <s.icon size={20} />
                <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full text-[10px] font-extrabold"
                      style={{ background: "#F5B400", color: "var(--green-950)" }}>
                  {i + 1}
                </span>
              </div>
              {i < STEPS.length - 1 && (
                <div className="mt-2 h-full w-px flex-1 lg:mt-0 lg:h-px lg:w-full" style={{ background: "#D1E7DD" }} />
              )}
            </div>
            <div className="pb-2">
              <h3 className="font-heading text-[15px] font-bold" style={{ color: "var(--green-950)" }}>{s.title}</h3>
              <p className="mt-1 text-[13px] leading-relaxed text-slate-500">{s.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
